export default {
  title: '重置密码',
  newPassword: '请输入新密码',
  newPasswordPlaceholder: '密码必须至少包含8个字母和数字',
  confirmPassword: '请再次输入新密码',
  confirmPasswordPlaceholder: '请输入',
  submit: '确认',
  passwordRequired: '请输入新密码',
  confirmPasswordRequired: '请确认新密码',
  passwordInvalid: '密码至少需要8个字符，包含字母和数字',
  passwordMismatch: '两次输入的密码不一致',
  tokenMissing: '抱歉，您没有访问权限，请联系管理员',
  resetSuccess: '密码重置成功，请重新登录',
  resetFailed: '密码重置失败',
};